import { useEffect, useState } from "react";
import meaMenuApi from "../api/meaMenuApi";

function groupMenuItemsByCategory(items) {
  const groups = new Map();

  (Array.isArray(items) ? items : []).forEach((menuItem) => {
    const categoryId = menuItem.menuCategoryId ?? 0;
    const categoryName = menuItem.categoryName || "Menu";
    const categorySortOrder = menuItem.categorySortOrder ?? 0;

    if (!groups.has(categoryId)) {
      groups.set(categoryId, {
        menuCategoryId: categoryId,
        categoryName,
        sortOrder: categorySortOrder,
        menuItems: [],
      });
    }

    groups.get(categoryId).menuItems.push(menuItem);
  });

  return Array.from(groups.values())
    .map((category) => ({
      ...category,
      menuItems: category.menuItems.filter((x) => x.isActive),
    }))
    .sort((a, b) => {
      const aSort = Number(a.sortOrder ?? 0);
      const bSort = Number(b.sortOrder ?? 0);
      return aSort - bSort;
    });
}

export default function useMenuData() {
  const [menuCategories, setMenuCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    const load = async () => {
      try {
        const res = await meaMenuApi.getOnlineMenu();
        if (!alive) return;

        const grouped = groupMenuItemsByCategory(res.data || []);
        if (!alive) return;

        setMenuCategories(grouped);
      } catch (err) {
        console.error("Error fetching Mea menu:", err);
        if (alive) setMenuCategories([]);
      } finally {
        if (alive) setLoading(false);
      }
    };

    load();

    return () => {
      alive = false;
    };
  }, []);

  return { menuCategories, loading };
}